module.exports = __webpack_public_path__ + "img/ios.bcb5a975.png";